import React from 'react'
import { Box, Typography, styled } from '@mui/material'
import { DeliveryRole } from '../../types/config'
import { OrderProps, ConsultoraProps } from '../../types/tracking'
import { formatDate } from '../../utils/format'
import { orderNumber } from '../../utils/utilities'
import DEFAULT from '../../config/default'

interface TolbarOrderProps {
    order: OrderProps
}

const TrackingOrderToolbar = ({ order }: TolbarOrderProps) => {
    
    const items: Array<{ label: React.ReactNode, text: React.ReactNode }> = []

    if (order.id) {
        items.push({ label: 'Pedido', text: orderNumber(order) })
    }

    if (order.ciclo !== undefined && order.ciclo && DEFAULT.api.countryCode === 'CO') {
        items.push({ label: 'Ciclo', text: order.ciclo })
    }

    if (order.idEvento !== 2) {
        if (order.fechaEntregaHasta) {
            items.push({
                label: 'Fecha estimada de entrega',
                text: `entre el ${ formatDate(order.fechaEntrega, 'd') }
                        y el ${ formatDate(order.fechaEntregaHasta, 'd') } de
                        ${ formatDate(order.fechaEntregaHasta, 'MMMM') }`
            })
        } else {
            if (order.fechaEntrega) {
            items.push({
                label: 'Fecha estimada de entrega hasta',
                text: order.fechaEntrega ? formatDate(order.fechaEntrega, 'DD.MM.YYYY') : ''
            })
            }
        }
    }

    if (order.bultosPorPedido) {
        items.push({ label: 'Cantidad de cajas', text: order.bultosPorPedido })
    }

    if (order.tipoDeEntrega) {
        const tipoDeEntrega = order.tipoDeEntrega.toLowerCase()
        if (
            tipoDeEntrega === DeliveryRole.address_es 
            ||
            tipoDeEntrega === DeliveryRole.address_pr
            ||
            tipoDeEntrega.startsWith(DeliveryRole.address_es_prefix)
        ) {
            if (order.detalleDeEntrega === 'agendada') {
                items.push({ label: `Tipo de entrega`, text: 'Programada' })
            } else {
                items.push({ label: `Tipo de entrega`, text: order.detalleDeEntrega })
            }
        } else if (tipoDeEntrega === DeliveryRole.branch_es || tipoDeEntrega === DeliveryRole.branch_pr) {
            items.push({ label: `Tipo de entrega`, text: 'Retiro en agencia' })
        }
    }

    return (
        <Toolbar items={items} />
    )
}

interface TolbarSellerProps {
    seller: ConsultoraProps,
    quantity: number
}

const TrackingSellerToolbar = ({ seller, quantity }: TolbarSellerProps) => {
    
    const items: Array<{ label: React.ReactNode, text: React.ReactNode }> = []

    if (seller) {
        if (seller.id) {
            items.push({ label: 'Código de consultor/a de belleza', text: seller.id })
        }
        if (seller.nombre) {
            items.push({ label: 'Nombre', text: seller.nombre })
        }
    }

    if (quantity) {
        items.push({ label: 'Cantidad de pedidos', text: quantity })
    }

    return (
        <Toolbar items={items} />
    )
}

interface ToolbarProps {
    items: Array<{ label: React.ReactNode, text: React.ReactNode }>,
    gutterBottom?: boolean
}

const Toolbar = ({ items, gutterBottom = true }: ToolbarProps) => {
    return (
        <ToolbarRootStyled ownerState={{ gutterBottom }}>
            <ListStyled>
                {items.map((value, index) => {
                    return (
                        <ItemStyled key={index}>
                            <Typography variant="body2">
                                <strong>{value.label}</strong> {value.text}
                            </Typography>
                        </ItemStyled>
                    )
                })}
            </ListStyled>
        </ToolbarRootStyled>
    )
}

const ToolbarRootStyled = styled(Box)<{ ownerState?: { gutterBottom?: boolean } }>(({ theme, ownerState }) => ({
    paddingTop: theme.spacing(2),
    background: theme.palette.background.default,
    // position: 'sticky',
    // top: 0,
    // left: 0,
    ...((ownerState?.gutterBottom) && {
        [theme.breakpoints.up('md')]: {
            paddingBottom: theme.spacing(2)
        },
        [theme.breakpoints.down('md')]: {
            paddingBottom: theme.spacing(1)
        }
    })
}))

const ListStyled = styled(Box)(({ theme }) => ({
    display: 'flex',
    [theme.breakpoints.up('md')]: {
        '& > div:not(:last-child)': {
            paddingRight: 8,
            marginRight: 8,
            borderRight: `1px solid ${ theme.palette.primary.main }`
        }
    },
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column'
    }
}))

const ItemStyled = styled(Box)(({ theme }) => ({
   lineHeight: 1
}))

export default Toolbar
export { TrackingOrderToolbar, TrackingSellerToolbar }
